/**
 * Users & Groups admin section tabs
 */

import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const ADMIN_TABS = [
  { id: 'users', label: 'Users', path: '/hub/settings' },
  { id: 'groups', label: 'Groups', path: '/hub/groups' },
]

export default function HubAdminTabs({ activeTab }) {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <div className="border-b border-gray-200 mb-6 relative">
      <div className="sm:hidden">
        <button
          type="button"
          onClick={() => setShowMenu(!showMenu)}
          className="w-full flex items-center justify-between px-4 py-3 text-base font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-500 touch-manipulation"
          aria-label="Select admin section"
        >
          <span>{ADMIN_TABS.find((tab) => tab.id === activeTab)?.label || 'Users'}</span>
          <svg
            className={`w-5 h-5 text-gray-500 transition-transform ${showMenu ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {showMenu && (
          <>
            <div
              className="fixed inset-0 bg-black/50 z-40"
              onClick={() => setShowMenu(false)}
              aria-hidden="true"
            />
            <div className="absolute left-0 right-0 mt-2 bg-white rounded-lg shadow-lg ring-1 ring-black/5 z-50">
              <div className="py-2">
                {ADMIN_TABS.map((tab) => (
                  <Link
                    key={tab.id}
                    to={tab.path}
                    onClick={() => setShowMenu(false)}
                    className={`block w-full text-left px-4 py-3 text-base touch-manipulation ${
                      activeTab === tab.id
                        ? 'bg-green-50 text-green-700 font-semibold'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    {tab.label}
                  </Link>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
      <nav className="hidden sm:flex -mb-px gap-6 whitespace-nowrap" aria-label="Admin sections">
        {ADMIN_TABS.map((tab) => (
          <Link
            key={tab.id}
            to={tab.path}
            className={`py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.id
                ? 'border-green-600 text-green-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
    </div>
  )
}
